export default __webpack_public_path__ + "static/media/GoodMannersAtSchool_01.97df8666.png";